import { HttpClient, HttpContext } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ResponseApi } from '../../../core/dtos/response-api';
import { HANDLE_HTTP_ERROR_LOCALLY, SKIP_SUCCESS_ALERT } from '../../../core/http/http-context-tokens';
import { AcessoServicoResponse } from '../models/servicos-favoritos.model';

const RECURSO = `${environment.apiUrl}/sai/cartaservico/MeusAcessosServico`;

const RECURSO_PUBLICO = `${environment.apiUrl}/sai/cartaservico/publico/servico`;

/** Sem modal de erro nem alerta de sucesso: o registro é invisível para o cidadão. */
const SILENCIOSO = () =>
  new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true).set(SKIP_SUCCESS_ALERT, true);

/**
 * As aberturas da página de um serviço, em dois contadores que não se somam:
 *
 * - `registrar`: o do cidadão logado — o "Mais acessados" da aba "Serviços favoritos", só
 *   com os acessos dele, contados mesmo sem favorito;
 * - `registrarPublico`: o de qualquer visitante, anônimo — o ranking de "Serviços mais
 *   procurados" da homepage.
 *
 * Quem decide QUANDO registrar (uma vez por abertura; o do cidadão, só com sessão) é a página
 * do serviço.
 */
@Service()
export class AcessosServicoService {
  private readonly http = inject(HttpClient);

  /**
   * Fire-and-forget **de propósito**: a assinatura fica aqui, e não no componente, porque
   * sair da página antes da resposta cancelaria a contagem. O erro é ignorado — a página não
   * muda por causa dele.
   */
  registrar(codServicoSrv: number): void {
    this.http
      .post<ResponseApi<AcessoServicoResponse>>(`${RECURSO}/${codServicoSrv}`, null, {
        context: SILENCIOSO(),
      })
      .subscribe({ error: () => undefined });
  }

  /**
   * A contagem pública, com ou sem sessão, pelo mesmo motivo do fire-and-forget acima. Um
   * 429 do teto por IP só perde esta contagem.
   */
  registrarPublico(codServicoSrv: number): void {
    this.http
      .post<ResponseApi<{ codServicoSrv: number }>>(
        `${RECURSO_PUBLICO}/${codServicoSrv}/acesso`,
        null,
        { context: SILENCIOSO() }
      )
      .subscribe({ error: () => undefined });
  }
}
